enum TransactionType {
  Sale = 0,
  PreAuth = 1,
  PreSalesCompletion = 2,
  CancelTransaction = 3,
  TaxFreeVoucher = 8,
  SaleWithToken = 12,
  RefundWithToken = 13,
  GetTerritory = 15,
  NewdayCardAccountPayment = 18,
  Returns = 20,
  PrintingDuplicateMerchantReceipt = 22,
  PrintingDuplicateCustomerReceipt = 23,
  CheckPinpadConnection = 24,
  GetTotalStoredOfflineTransactions = 25,
  GetPinpadSerialNumber = 26,
  CheckCard = 30,
  CheckStatus = 34,
  LastTransactionResult = 35,
  XReport = 36,
  ZReport = 37,
  GiftCardRedemption = 51,
  GiftCardRefund = 52,
  GiftCardTopUp = 53,
  GiftCardCheckBalance = 55,
  AccountVerificationRequest = 58,
  HideIPCWindow = 90,
  ShowIPCWindow = 91,
  CloseIPCWindow = 99
}

export default TransactionType;
